"use client";

import dynamic from "next/dynamic";
import { useMemo } from "react";
import { SortAsc, SortDesc, Banknote, Star } from "lucide-react";
import useClientRouter from "@/hooks/useClientRouter";

// SSR disable üçün Select dinamik import
const Select = dynamic(() => import("react-select"), { ssr: false });

const SortBy = ({ t }) => {
  const { params, setPropertyToUrl } = useClientRouter("products");

  const sortOptions = [
    {
      direction: "ASC",
      order_by: "title",
      value: "ASC&title",
      label: t["filter.from_a_to_z"],
      icon: <SortAsc size={16} />,
    },
    {
      direction: "DESC",
      order_by: "title",
      value: "DESC&title",
      label: t["filter.from_z_to_a"],
      icon: <SortDesc size={16} />,
    },
    {
      direction: "DESC",
      order_by: "rating",
      value: "DESC&rating",
      label: t["filter.popularity"],
      icon: <Star size={16} />,
    },
    {
      direction: "ASC",
      order_by: "min_price",
      value: "ASC&min_price",
      label: t["filter.cheap_to_expensive"],
      icon: <Banknote size={16} />,
    },
    {
      direction: "DESC",
      order_by: "min_price",
      value: "DESC&min_price",
      label: t["filter.expensive_to_cheap"],
      icon: <Banknote size={16} />,
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "1px solid transparent",
      boxShadow: "none",
      borderRadius: "8px",
      padding: "4px",
      cursor: "pointer",
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      zIndex: "3",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#f0f0f0" : "white",
      color: "#1E1E1E",
      fontSize: "1.6rem",
      fontWeight: "400",
      "&:hover": {
        backgroundColor: "#ddd",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aaa",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.selectProps.menuIsOpen
        ? "rotate(180deg)"
        : "rotate(0deg)",
      transition: "transform 0.2s ease",
    }),
  };

  const selectedValue = useMemo(() => {
    return sortOptions.find(
      (option) =>
        option.order_by === params.get("order_by") &&
        option.direction === params.get("direction")
    );
  }, [params.get("order_by"), params.get("direction")]);

  return (
    <div className="sortBy">
      <div className="sortBox">
        <Select
          className="customSelect"
          options={sortOptions.map(({ icon, ...rest }) => rest)}
          value={
            selectedValue
              ? {
                  value: selectedValue.value,
                  label: (
                    <div className="selectedOption">
                      {selectedValue.icon} {selectedValue.label}
                    </div>
                  ),
                }
              : null
          }
          onChange={(selected) => {
            setPropertyToUrl("order_by", selected.order_by);
            setPropertyToUrl("direction", selected.direction);
          }}
          isSearchable={false}
          styles={customStyles}
        />
      </div>
    </div>
  );
};

export default SortBy;
